import { ArrowUpDown, ChevronDown, ChevronUp } from "lucide-react";

const COLUNAS = [
  { key: "name", label: "Produto", cls: "text-left pl-5" },
  { key: "cmv", label: "CMV", cls: "text-right" },
  { key: "venda", label: "Venda", cls: "text-right" },
  { key: "lucro", label: "Lucro", cls: "text-right" },
  { key: "margin", label: "Margem", cls: "text-right" },
  { key: "salesShare", label: "% Vendas 30d", cls: "text-right pr-5" },
];

function IconeOrdem({ ativo, dir }) {
  if (!ativo) return <ArrowUpDown className="w-3 h-3 opacity-30" />;
  return dir === "asc" ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />;
}

/** Cabeçalho clicável: a mesma ordem vale para as categorias e para os produtos dentro delas. */
export default function CabecalhoCmv({ sort, onSort, primeiraColuna = "Produto" }) {
  return (
    <thead className="bg-muted/60 sticky top-0 z-10">
      <tr>
        {COLUNAS.map(({ key, label, cls }) => (
          <th
            key={key}
            onClick={() => onSort(key)}
            className={`py-2.5 px-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground cursor-pointer hover:text-foreground select-none ${cls}`}
          >
            <span className="inline-flex items-center gap-0.5">
              {key === "name" ? primeiraColuna : label}
              <IconeOrdem ativo={sort.key === key} dir={sort.dir} />
            </span>
          </th>
        ))}
      </tr>
    </thead>
  );
}
